/* globals Class, $H */
window.jui.HelpButton = Class.create(window.jui.Component, {
  options: function($super,options){
    return $super($H({
      elementType: 'a'
      }).merge(options));
  },

  initialize: function($super, href, title) {
    $super({attributes:{
      href: href,
      title: title,
      className: 'help-button',
      target: '_blank'
      }});
  }
});

window.jui.HelpButtonCustomizable = Class.create(window.jui.Component, {
  options: function($super,options){
    return $super($H({
      elementType: 'a'
      }).merge(options));
  },

  initialize: function($super, options) {
    $super({attributes:{
      href: options.attributes.href || '#',
      className: options.attributes.className || 'help-button',
      target: options.attributes.target
    }});
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/jui/help_button.js
// module id = 322
// module chunks = 0 1